import { isOneToOneChat } from "@/firebase/utils";
import { GroupRawChat, RawChat } from "@/store/chats/types";

export const getIsGroupRawChat = (
  rawChat: RawChat,
): rawChat is GroupRawChat => {
  return !isOneToOneChat(rawChat.id);
};
